import { Container } from "reactstrap"
import LoadScreen from "../UI/LoadScreen"
import { ClientsList } from "./ClientsList"
import { useGetClientsQuery } from "../../features/CallApi"
import { useState } from "react"
import { useNavigate } from "react-router-dom"


export const Clients = () => {
    const navigate = useNavigate();
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [stringFilter, setStringFilter] = useState("");
    const { data: clients, isLoading, error, refetch } = useGetClientsQuery({ pageIndex, pageSize, stringFilter })

    return (
        <Container>
            <h3>Клиенты</h3>
            {error ?
                <div>
                    {error && <div>
                        <h1>Error code: {error.status}</h1>
                        <p>{error.data}</p>
                    </div>
                    }
                </div> :
                <div>
                    <div className="d-flex">
                        <input type={`text`} id="stringFilter" onChange={
                            (e) => setTimeout(() => { setStringFilter(e.target.value) }, 2000)}
                            placeholder="Поиск.." name="stringFilter" className="form-control" />
                    </div>
                    <div>
                        {isLoading ?
                            <LoadScreen /> :
                            <ClientsList pageIndex={pageIndex} setPageIndex={setPageIndex} navigate={navigate} clients={clients.getClients} totalPages={clients.totalPages} />
                        }
                    </div>
                </div>
            }
        </Container>
    )

}